import React, { createContext, useContext, useState } from "react";

type Menus = {
  code_name: string;
  sub_menus: Menus[];
};

type AllPanels = {
  name: string;
  uid: string;
  type: string;
  state: string;
  notifications: number;
  menus: Menus[];
};

type PanelInfo = {
  admin: boolean;
  panels: AllPanels[];
};

interface IUserData {
  notification_count: number;
  panels: PanelInfo;
  username: string;
  phone_number: string;
  user_uid: string;
}

interface UserContextState {
  userData: IUserData;
  setUserData: React.Dispatch<React.SetStateAction<any>>;
}

const UserContext = createContext<UserContextState | undefined>(undefined);

export { UserContext };

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUserContext must be used within a UserContextProvider");
  }
  return context;
};

export const UserContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [userData, setUserData] = useState<any>(null);

  const value = { userData, setUserData };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
